<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/sys/util/url'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import axios from 'axios'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {

      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.domainMapping.edit:URL.domainMapping.save,model,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("操作成功");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[

                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: '操作接口', field: 'name'},
              { title: '请求方式', field: 'type',type:2,optionList:{"POST":"POST","GET":"GET"}},
              { title: '操作用户', field: 'user'},
              { title: '操作时间', field: 'time',type:6},
              {click:"查询"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.userMonitor.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '操作接口', field: 'name'},
                          { title: '参数', field: 'params'},
                          { title: '方式', field: 'type'},
                          { title: '操作人', field: 'user'},
                          { title: '操作时间', field: 'time',render:(data,full)=>{
                                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                              }}
          ]
        }
      }
    }
  }
</script>
